/**
 * Patient Status Reason Constants
 *
 * Values synced with backend PatientStatusReasonEnum.
 * @see backend/src/backend/db/constants/patient_status_reason.py
 */
import { intl } from "dmsbasereact";

// Enum names (keys stored in database)
export const PatientStatusReasonEnum = {
    GESTATION: "GESTATION",
    DEATH: "DEATH",
    DISEASE_PROGRESSION: "DISEASE_PROGRESSION",
    THERAPEUTIC_CHANGE: "THERAPEUTIC_CHANGE",
    BRAND_CHANGE: "BRAND_CHANGE",
    TREATMENT_COMPLETED: "TREATMENT_COMPLETED",
    PATIENT_REQUEST: "PATIENT_REQUEST",
    MEDICAL_RECOMMENDATION: "MEDICAL_RECOMMENDATION",
};

export const PatientStatusReason = {
    /**
     * Get translated text for a patient status reason name
     * @param {string} name - The reason name (enum key)
     * @returns {string} Translated text
     */
    getText: (name) => {
        switch (name) {
            case PatientStatusReasonEnum.GESTATION:
                return intl.get("GESTATION").d("Gestation");
            case PatientStatusReasonEnum.DEATH:
                return intl.get("DEATH").d("Death");
            case PatientStatusReasonEnum.DISEASE_PROGRESSION:
                return intl.get("DISEASE_PROGRESSION").d("Disease Progression");
            // Keep historical reasons for display of old records:
            case "ADVERSE_REACTION":
                return intl.get("ADVERSE_REACTION").d("Adverse Reaction");
            case "INEFFECTIVENESS":
                return intl.get("INEFFECTIVENESS").d("Treatment Ineffectiveness");
            // Active reasons:
            case PatientStatusReasonEnum.THERAPEUTIC_CHANGE:
                return intl.get("THERAPEUTIC_CHANGE").d("Therapeutic Change");
            case PatientStatusReasonEnum.BRAND_CHANGE:
                return intl.get("BRAND_CHANGE").d("Brand Change");
            case PatientStatusReasonEnum.TREATMENT_COMPLETED:
                return intl.get("TREATMENT_COMPLETED").d("Treatment Completed");
            case PatientStatusReasonEnum.PATIENT_REQUEST:
                return intl.get("PATIENT_REQUEST").d("Patient Request");
            case PatientStatusReasonEnum.MEDICAL_RECOMMENDATION:
                return intl.get("MEDICAL_RECOMMENDATION").d("Medical Recommendation");
            default:
                return name || intl.get("Unknown").d("Unknown");
        }
    },
};

/**
 * Hook to get patient status reason options for select components
 * @returns {Function} Function that returns translated options
 */
export const usePatientStatusReasonOptions = () => {
    return Object.values(PatientStatusReasonEnum).map(name => ({
        value: name,
        label: PatientStatusReason.getText(name),
    }));
};
